import { ICustomizerApiFilter } from './customizer-api-filter';
import { ICustomizerApiFilterOption } from './customizer-api-filter-option';
import { FilterOption } from './filter-option';

export class CustomizerFilter implements ICustomizerApiFilter {
  public available = true;
  public name: string;
  public options: FilterOption[];
  public summary: string;
  public title: string;

  constructor(apiFilter: ICustomizerApiFilter) {
    this.name = apiFilter.name;
    this.options = apiFilter.options.map((o: ICustomizerApiFilterOption) => new FilterOption(o));
    this.summary = apiFilter.summary;
    this.title = apiFilter.title;
  }

  public get hasValue(): boolean {
    return this.options.some((x: FilterOption) => x.checked);
  }

  public get value(): string | undefined {
    if (!this.hasValue) {
      return undefined;
    }

    return this.checkedOption.value;
  }

  public get checkedOption(): FilterOption | undefined {
    return this.options.filter((x: FilterOption) => x.checked)[0];
  }
}
